<template>
  <main>
    <div class="dashboard-style">
      <div class="row">
        <TopTemplate>
          <template v-slot:right-element> </template>
          <template v-slot:left-element>
            <h3>
              {{ $t("title.bienvenue") }}
              <!-- Écoles -->
            </h3>
          </template>
        </TopTemplate>
        <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
          <div class="spinner-border text-info" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-if="!loading" class="row">
          <div :class="!news && !events.length ? 'col-xl-12 col-md-12' : 'col-xl-9 col-md-12'">
            <div class="row">
              <div class="mb-3" :class="{'d-none': !allSold, 'col-md-5': allSold}">
                <div class="card">
                  <div class="card-body subscriber-total">
                    <div class="indicator-students classes">
                      <!-- <div class="block-total classes">
                                <i class="icon-student icon-stand"></i>
                            </div> -->
                      <!-- <div><i class="material-icons icon-stand" /></div> -->
                      <div class="text-bloc">
                        <p>{{ users.nb_classes }}</p>
                        <p class="title-total">{{ $t("dashboard.classes") }}</p>
                      </div>
                    </div>
                    <div class="indicator-students students">
                      <!-- <div>
                        <i class="material-icons icon-graduation-hat" />
                      </div> -->
                      <div class="text-bloc">
                        <p>{{ users.nb_students }}</p>
                        <p class="title-total">{{ $t("dashboard.student") }}</p>
                      </div>
                    </div>
                    <div class="indicator-students teachers">
                      <!-- <div><i class="material-icons icon-teacher" /></div> -->
                      <div class="text-bloc">
                        <p>{{ users.nb_teachers }}</p>
                        <p class="title-total">{{ $t("dashboard.teacher") }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!loadingSold && allSold" class="col-md-7">
                <div class="row gx-2 solde-row solde-row-dashboard">
                  <div class="col-md-4 margin-div margin-div-dashboard">
                    <div class="default-border default-border-dashboard">
                      <div class="icon-mony icon-mony-dashboard">
                        <div class="image-mony image-mony--image1">
                          <img src="../assets/icons/Money.svg" />
                        </div>
                        <h3>{{ separerParTroisChiffres(allSold.total) }}Dt</h3>
                      </div>
                      <span>{{ $t("title.TotalSold") }}</span>
                    </div>
                  </div>
                  <div class="col-md-4 margin-div margin-div-dashboard">
                    <div class="default-border default-border-dashboard">
                      <div class="icon-mony icon-mony-dashboard">
                        <div class="image-mony image-mony--image2">
                          <img src="../assets/icons/Vector.svg" />
                        </div>
                        <h3>+{{ separerParTroisChiffres(allSold.positive) }}Dt</h3>
                      </div>
                      <span>{{ $t("title.PositifSold") }}</span>
                    </div>
                  </div>
                  <div class="col-md-4 margin-div margin-div-dashboard">
                    <div class="default-border default-border-dashboard">
                      <div class="icon-mony icon-mony-dashboard">
                        <div class="image-mony image-mony--image3">
                          <img src="../assets/icons/Vector-1.svg" />
                        </div>
                        <h3>{{ separerParTroisChiffres(allSold.negative) }}Dt</h3>
                      </div>
                      <span class="ml-25">{{ $t("title.negatifSold") }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" ref="topBloc">
              <div class="mb-3 count-classes" :class="{'col-md-5': !allSold, 'd-none': allSold}">
                <div class="card">
                  <div class="card-body subscriber-total">
                    <div class="indicator-students classes">
                      <!-- <div class="block-total classes">
                                <i class="icon-student icon-stand"></i>
                            </div> -->
                      <!-- <div><i class="material-icons icon-stand" /></div> -->
                      <div class="text-bloc">
                        <p>{{ users.nb_classes }}</p>
                        <p class="title-total">{{ $t("dashboard.classes") }}</p>
                      </div>
                    </div>
                    <div class="indicator-students students">
                      <!-- <div>
                        <i class="material-icons icon-graduation-hat" />
                      </div> -->
                      <div class="text-bloc">
                        <p>{{ users.nb_students }}</p>
                        <p class="title-total">{{ $t("dashboard.student") }}</p>
                      </div>
                    </div>
                    <div class="indicator-students teachers">
                      <!-- <div><i class="material-icons icon-teacher" /></div> -->
                      <div class="text-bloc">
                        <p>{{ users.nb_teachers }}</p>
                        <p class="title-total">{{ $t("dashboard.teacher") }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3 count-users" :class="{'col-md-7': !allSold, 'col-md-12': allSold}">
                <div class="card">
                  <div class="card-body row dashboard-indicators">
                    <div class="col-md-4 d-flex align-items-center">
                      <div class="icon-unpaid">
                        <i class="indicator-icon icon-users"></i>
                      </div>
                      <div class="separator-left">
                        <p class="pay-value">{{ users.nb_users }}</p>
                        <p class="title-total">{{ $t("dashboard.totalUser") }}</p>
                      </div>
                    </div>
                    <div class="col-md-4 blocs">
                      <div class="one-item">
                        <h3>{{ users.count_student_connected }}</h3>
                        <span>Elèves</span>
                      </div>
                      <div class="one-item">
                        <h3>{{ users.count_teacher_connected }}</h3>
                        <span>Enseignants</span>
                      </div>
                      <div class="one-item">
                        <h3>{{ users.count_parent_connected }}</h3>
                        <span>Parents</span>
                      </div>
                      <div class="one-item">
                        <h3>{{ users.count_admin_school }}</h3>
                        <span>{{ $t("dashboard.admin") }}</span>
                      </div>
                    </div>
                    <div class="col-md-4 badge-v-mobile">
                      <div class="percent-value me-2">
                        <i class="badge-icon ri-apple-fill"></i>
                        <p>{{ users.nb_ios_users }}</p>
                      </div>
                      <div class="percent-value">
                        <i class="badge-icon ri-android-fill"></i>
                        <p>{{ users.nb_android_users }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-5 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">{{ $t("dashboard.nbDevoir") }}</h5>
                    <p class="nbr-day">{{ $t("dashboard.periodeJour") }}</p>
                    <DonutChart v-if="displayChartDev" :chart-data="chartDataDevoirs" :pluginsDevoir="pluginsDevoir" :cutoutDg="100" :heightDg="300" :position="'bottom'" />
                    <div class="bloc-info-exam">
                      <div class="bloc-1">
                        <span class="nb-exam">{{ chartDataDevoirs.datasets[0].data[0] }}</span>
                      </div>
                      <div class="bloc-2">
                        <span class="nb-exam">{{ chartDataDevoirs.datasets[0].data[1] }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-7 mb-3">
                <div class="card h-100">
                  <div class="card-body card-cnx">
                    <div class="info-cnx">
                      <h5 class="card-title">{{ $t("dashboard.nbCnx") }}</h5>
                      <p class="nbr-day">{{ titleType }}</p>
                      <span>{{ sumCnx }}</span>
                    </div>
                    <div class="type-filter">
                      <v-select
                        v-model="filtterDate"
                        auto
                        :searchable="false"
                        :options="types"
                        label="name"
                        :reduce="(option) => option"
                        class="form-control"
                        @update:modelValue="changeType($event)"
                      >
                      </v-select>
                    </div>
                    <BarChart v-if="displayCharCnx" :chart-data="chartDataConnexions" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">{{ $t("dashboard.msgSend") }}</h5>
                    <p class="nbr-day">{{ $t("dashboard.periodeJour") }}</p>
                    <LineCharts v-if="displayCharMsg" :chart-data="chartDataMessages" :height-line="heightLine" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-12" ref="rightBloc">
            <div class="row">
              <div v-if="news" class="col-xl-12 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body dashboard-news">
                    <h5 class="card-title">{{ $t("dashboard.article") }}</h5>
                    <div class="d-flex justify-content-center mb-3">
                      <img :src="news?.mid_size_url" class="img-ecole" />
                    </div>
                    <router-link
                      :to="{
                        name: 'DetailsArticle',
                        params: {id: news?.id},
                      }"
                    >
                      <h2 :class="{'arabic-text': checkLanguag(news?.title)}">
                        {{ news?.title }}
                      </h2></router-link
                    >
                    <router-link
                      :to="{
                        name: 'DetailsArticle',
                        params: {id: news?.id},
                      }"
                    >
                      <div class="text-news" v-html="news?.content"></div
                    ></router-link>
                    <p class="date-news">
                      {{ formatDateNews(news?.created_at) }}
                    </p>

                    <!--  <router-link
                        :to="{
                          name: 'DetailsArticle',
                          params: { id: news?.id },
                        }"
                        class="navigation-news read-more-news"
                      >
                        Lire la suite
                      </router-link> -->

                    <router-link :to="{name: 'articleList'}" class="navigation-news">{{ $t("dashboard.aLire") }}</router-link>
                  </div>
                </div>
              </div>
              <div v-if="events.length" class="col-xl-12 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">{{ $t("dashboard.event") }}</h5>
                    <div class="block-event">
                      <div v-for="(item, index) in dateEvt" :key="index">
                        <div
                          class="event-item"
                          :class="{
                            'active-event': sameDate(item.start),
                          }"
                        >
                          <p class="date-label">
                            {{ item.name }}
                          </p>
                          <div v-for="(title, i) in eventName(item.start, item.end)" :key="index1" class="badge">
                            <p class="description">{{ title }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <router-link :to="{name: 'eventsList'}" class="navigation-news">{{ $t("dashboard.voirTous") }}</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../components/toptemplate/TopTemplate.vue";
import Datepicker from "@vuepic/vue-datepicker";
import DashboardService from "../services/dashboard.service";
import EventService from "../services/events.service";
import LineCharts from "../components/statistics/lineCharts.vue";
import DonutChart from "../components/statistics/donutChart.vue";
import BarChart from "../components/statistics/barChart.vue";
import moment from "moment";
import vSelect from "vue-select";
const BY_DAYS = 1;
const BY_MONTH = 2;
const BY_YEARS = 3;
export default {
  name: "DashboardPage",
  components: {
    TopTemplate,
    Datepicker,
    LineCharts,
    DonutChart,
    BarChart,
    "v-select": vSelect,
  },
  data() {
    return {
      news: null,
      types: [
        {id: 1, number: 6, type: "day", name: "7 jours"},
        {id: 2, number: 29, type: "day", name: "30 jours"},
        {id: 3, number: 11, type: "month", name: "12 mois"},
      ],
      titleType: "Sur les 7 derniers jours",
      filtterDate: {id: 1, number: 6, type: "day", name: "7 jours"},
      displayChartDev: false,
      displayCharCnx: false,
      displayCharMsg: false,
      sumCnx: 0,
      loading: true,
      heightLine: 0,
      teachers: [],
      students: [],
      dateSearch: [],
      classes: [],
      devoirs: [],
      messages: [],
      dateCourant: null,
      users: [],
      events: [],
      eventDate: [],
      params: {
        sort: "created_at",
        order: false,
      },
      dateEvt: null,
      chartDataMessage: {
        labels: ["Sep", "Oct", "Nov", "Jan", "Fev", "Mar", "Avr", "Mai", "Jui", "Juil", "Aou"],
        datasets: [
          {
            label: "Total messages",
            backgroundColor: (ctx) => {
              const canvas = ctx.chart.ctx;
              const gradient = canvas.createLinearGradient(180, 0, 0, 0);
              gradient.addColorStop(0, "#34b9bb33");
              gradient.addColorStop(0.5, "#34b9bb33");
              gradient.addColorStop(1, "#34b9bb00");

              return gradient;
            },
            borderColor: "#34B9BB",
            fill: true,
            radius: 0,
            data: [40, 20, 12],
          },
          {
            label: "Messages lus",
            // backgroundColor: "#fcc43e33",
            backgroundColor: (ctx) => {
              const canvas = ctx.chart.ctx;
              const gradient = canvas.createLinearGradient(180, 0, 0, 0);
              gradient.addColorStop(0, "#fcc43e33");
              gradient.addColorStop(0.5, "#fcc43e33");
              gradient.addColorStop(1, "#fcc43e00");

              return gradient;
            },
            borderColor: "#FCC43E",
            fill: true,
            radius: 0,
            data: [70, 30, 5],
          },
          {
            label: "Messages non lus",
            // backgroundColor: "#fb7d5b33",
            backgroundColor: (ctx) => {
              const canvas = ctx.chart.ctx;
              const gradient = canvas.createLinearGradient(180, 0, 0, 0);
              gradient.addColorStop(0, "#fb7d5b33");
              gradient.addColorStop(0.5, "#fb7d5b33");
              gradient.addColorStop(1, "#fb7d5b00");

              return gradient;
            },
            borderColor: "#FB7D5B",
            fill: true,
            radius: 0,
            data: [5, 10, 12],
          },
        ],
      },
      chartDataMessages: {
        labels: [],
        datasets: [
          {
            label: "Total messages",
            backgroundColor: (ctx) => {
              const canvas = ctx.chart.ctx;
              const gradient = canvas.createLinearGradient(180, 0, 0, 0);

              gradient.addColorStop(0, "#34b9bb33");
              gradient.addColorStop(0.5, "#34b9bb33");
              gradient.addColorStop(1, "#34B9BB00");
              return gradient;
            },
            borderColor: "#34B9BB",
            hoverBackgroundColor: "red",
            fill: true,
            radius: 0,
            data: [],
          },
          {
            label: "Messages lus",
            backgroundColor: (ctx) => {
              const canvas = ctx.chart.ctx;
              const gradient = canvas.createLinearGradient(180, 0, 0, 0);

              gradient.addColorStop(0, "#fcc43e33");
              gradient.addColorStop(0.5, "#fcc43e33");
              gradient.addColorStop(1, "#fcc43e00");
              return gradient;
            },
            borderColor: "#FCC43E",
            fill: true,
            radius: 0,
            data: [],
          },
          {
            label: "Messages non lus",
            backgroundColor: (ctx) => {
              const canvas = ctx.chart.ctx;
              const gradient = canvas.createLinearGradient(180, 0, 0, 0);
              gradient.addColorStop(0, "#fb7d5b33");
              gradient.addColorStop(0.5, "#fb7d5b33");
              gradient.addColorStop(1, "#fb7d5b00");

              return gradient;
            },
            borderColor: "#FB7D5B",
            fill: true,
            radius: 0,
            data: [],
          },
        ],
      },
      chartDataDevoirs: {
        type: "doughnut",
        labels: ["Anciens", "A venir"],
        datasets: [
          {
            backgroundColor: ["#377879", "#E9F0F0"],
            data: [],
            borderWidth: 2,
            borderRadius: 0,

            // angle: [50],
            // borderRadius: [{ innerStart: 50, outerStart: 50, innerEnd: 50, outerEnd: 50}],
            // spacing: -50,
          },
        ],
      },
      pluginsDevoir: [
        {
          id: "nb-devoir",
          beforeDraw: function (chart) {
            var width = chart.chartArea.width,
              height = chart.chartArea.height,
              ctx = chart.ctx;
            ctx.restore();
            ctx.font = "bold 50px Inter, serif";
            ctx.textBaseline = "middle";
            const visibleData = chart.data.datasets[0].data.filter((_, index) => chart.getDataVisibility(index));
            const sum = visibleData.reduce((acc, curr) => acc + curr, 0);

            var text = sum,
              textX = Math.round((width - ctx.measureText(text).width) / 2),
              textY = height / 2;
            ctx.fillStyle = "#1C1C1C";
            ctx.fillText(text, textX, textY);
            ctx.save();
          },
        },
        {
          id: "text-devoir",
          beforeDraw: function (chart) {
            var width = chart.chartArea.width,
              height = chart.chartArea.height,
              ctx = chart.ctx;

            ctx.restore();
            ctx.font = "16px Inter, serif";
            ctx.textBaseline = "middle";

            var text = "",
              textX = Math.round((width - ctx.measureText(text).width) / 2),
              textY = height / 1.62;
            ctx.fillStyle = "#A098AE";
            ctx.fillText(text, textX, textY);
            ctx.save();
          },
        },
      ],
      chartDataConnexions: {
        labels: [],
        datasets: [
          {
            label: "Visiteurs",
            backgroundColor: "#D6F1F1",
            hoverBackgroundColor: "#34B9BB",
            pointBorderColor: "#fff",
            borderRadius: 10,
            borderSkipped: false,
            maxBarThickness: 50,
            data: [],
          },
        ],
      },
      allSold: null,
      loadingSold: false,
    };
  },
  computed: {},
  mounted() {
    this.getAllData();
    this.getEvent();
    this.getSolde();
  },
  methods: {
    changeType(event) {
      this.titleType = "";

      switch (event.id) {
        case BY_DAYS:
          this.titleType = "Sur les 7 derniers jours";
          break;
        case BY_MONTH:
          this.titleType = "Sur les 30 derniers jours";
          break;
        case BY_YEARS:
          this.titleType = "Sur les 12 derniers mois";
          // Expected output: "Mangoes and papayas are $2.79 a pound."
          break;
        default:
          this.titleType = "Sur les 7 derniers jours";
      }
      this.displayCharCnx = false;
      DashboardService.getNbCnx({
        params: {filter: this.filtterDate.number, type: this.filtterDate.type},
      }).then((response) => {
        this.loadGraphConexion(response, this.filtterDate.id, this.filtterDate.type);
      });
    },
    formatDate(date) {
      /*   let eventcourant= []
      this.events.forEach(function(event){
        if(date === event.start && event.end === null){
          eventcourant.push(event.title)
        }
      })
      this.eventDate = eventcourant */
      moment.locale("fr");
      return moment(date).format("D MMMM");
    },
    formatDateJour(date) {
      moment.locale("fr");
      return moment(date).format("D");
    },
    formatDateMois(date) {
      return moment(date).format("MMM");
    },
    formatDateCourant(date) {
      moment.locale("fr");
      return moment(date).format("D MMM");
    },
    formatDateNews(date) {
      return moment(date).format("D MMMM YYYY");
    },
    sameDate(date) {
      let dateEv = moment(date).format("DD-MM-YYYY");
      let dateCrnt = moment().format("DD-MM-YYYY");
      return dateEv === dateCrnt;
    },
    loadGraphConexion(data, type) {
      let days = [];
      data.data[0].map((item, index) => {
        moment.locale("fr");
        let dt = moment(item, "YYYY-MM-DD HH:mm:ss");
        let BY_DAYS = this.filtterDate.id;

        switch (type) {
          case 1:
            dt = dt.format("dddd").substring(0, 3);
            dt = dt.charAt(0).toUpperCase() + dt.slice(1);
            break;
          case 2:
            dt = dt.format("DD MMMM").replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase());
            break;
          case 3:
            dt = dt.format("MMMM YYYY").replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase());
            // Expected output: "Mangoes and papayas are $2.79 a pound."
            break;
          default:
            dt = dt.format("dddd").substring(0, 3);
        }
        days.push(dt);
      });
      let valDay;

      if (type === "last-12-months") {
        valDay = data.data[1];
        this.chartDataConnexions.labels = days;
      } else {
        valDay = data.data[1].reverse();
        this.chartDataConnexions.labels = days.reverse();
      }
      this.sumCnx = valDay.reduce((partialSum, a) => partialSum + a, 0);

      this.chartDataConnexions.datasets[0].data = valDay;
      this.displayCharCnx = true;
    },
    getAllData() {
      this.loading = true;
      allRequests([
        DashboardService.getAllUser(),
        DashboardService.getAllHmw(),
        DashboardService.getNbCnx({params: {filter: this.filtterDate.number, type: this.filtterDate.type}}),
        DashboardService.getAllMsgByMonth(),
        DashboardService.getLast(),
      ])
        .then((responses) => {
          this.users = responses[0].data;

          this.news = responses[4].data.length === 0 ? null : responses[4].data.data;
          var dataDevor = [responses[1].data[0][0], responses[1].data[0][1] - responses[1].data[0][0]];
          this.chartDataDevoirs.datasets[0].data = dataDevor;
          this.displayChartDev = true;
          this.loadGraphConexion(responses[2], 1, "day");
          let statMessage = responses[3].data.data;
          let DayMessage = [];
          let valMessageTot = [];
          let valMessageNotLu = [];
          let valMessagetLu = [];
          let emptytotalMsg = true;
          let emptyLuMsg = true;
          let emptyNotLuMsg = true;
          statMessage.map((item, index) => {
            moment.locale("fr");
            let dt = moment(item.day).format("DD/MM");

            DayMessage.push(dt);

            if (item.nbr_message_tot > 0) emptytotalMsg = false;
            if (item.nbr_message_non_lu > 0) emptyLuMsg = false;
            if (item.nbr_message_lu > 0) emptyNotLuMsg = false;
            valMessageTot.push(item.nbr_message_tot);
            valMessageNotLu.push(item.nbr_message_non_lu);
            valMessagetLu.push(item.nbr_message_lu);
          });
          if (emptytotalMsg) valMessageTot = [];
          if (emptyLuMsg) valMessagetLu = [];
          if (emptyNotLuMsg) valMessageNotLu = [];
          this.chartDataMessages.labels = DayMessage;
          this.chartDataMessages.datasets[0].data = valMessageTot;
          this.chartDataMessages.datasets[1].data = valMessagetLu;
          this.chartDataMessages.datasets[2].data = valMessageNotLu;
        })
        .finally(() => {
          this.loading = false;
          let that = this;

          setTimeout(function () {
            let heightRight = that.$refs.rightBloc.clientHeight;
            if (heightRight < 809) heightRight = 809;
            let topHeight = that.$refs.topBloc.clientHeight;
            let bottomBloc = heightRight - topHeight;
            that.heightLine = bottomBloc - 99;
            that.displayCharMsg = true;
          }, 500);
        });
    },

    eventsDate(events) {
      const that = this;
      this.dateEvt = events.reduce(function (previous, current, index) {
        let index1 = that.checkEvent(previous, current);
        if (index1 === -1) {
          if (that.formatDateMois(current.start) === that.formatDateMois(current.end) && current.end != current.start) {
            current.name = that.formatDateJour(current.start) + " - " + that.formatDateCourant(current.end);
          } else if (current.end && current.end != current.start) {
            current.name = that.formatDateCourant(current.start) + " - " + that.formatDateCourant(current.end);
          } else {
            current.name = that.formatDate(current.start);
          }
          previous.push(current);
        }
        return previous;
      }, []);
    },

    checkEvent(prev, curr) {
      let index = -1;
      Object.keys(prev).forEach(function (item) {
        if (prev[item].start === curr.start && prev[item].end === curr.end) index = item;
      });
      return index;
    },
    getEvent() {
      this.loading = true;
      EventService.getComming().then((response) => {
        this.events = response.data.data;
        this.eventsDate(this.events);
      });
    },

    eventName(start, end) {
      let data = this.events.filter((ev) => ev.start === start && ev.end === end).map((ev) => ev.title);
      return data;
    },

    checkLanguag(val) {
      const arabic = /[\u0600-\u06FF]/;
      return arabic.test(val); // displays true
    },
    separerParTroisChiffres(nombre) {
      let nombreEnChaine = nombre.toString();
      nombreEnChaine = nombreEnChaine.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return nombreEnChaine;
    },
    async getSolde() {
      this.loadingSold = true;
      try {
        const res = await DashboardService.getSolde();
        this.allSold = res.data.result;
        this.loadingSold = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingSold = false;
      }
    },
  },
};
</script>
<style>
.text-bloc {
  text-align: center;
  width: 100%;
  position: relative;
  padding: 5px;
}
.event-item p {
  display: flex;
}
a h2,
.text-news {
  text-decoration: none;
  text-transform: ini;
}
.dashboard-style a {
  text-decoration: none;
}
</style>
